import {
  NewspaperIcon,
  ArchiveIcon,
  LogoutIcon,
  UserIcon,
  BellIcon,
  UsersIcon,
  HomeIcon,
  ChatIcon
} from "@heroicons/react/outline";

import React from "react";
import { Outlet, NavLink } from "react-router-dom";
import logo from "../../logo.jpeg";

import ProfileImg from "../../images/profile.png";
import MobileMenu from "./MobileMenu";
import { useUser } from "../contexts/UserProvider";

const ShellLayout = () => {
  const { user, logout, globalNotifications } = useUser();

  return (
    <div className="flex">
      <div className="hidden md:flex flex-col justify-between p-2 bg-gray-100 sticky top-0 h-screen max-w-[100px]">
        <div>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "bg-gray-200 flex flex-col items-center px-4 py-2 rounded-lg mb-4"
                : "flex flex-col items-center px-4 py-2 rounded-lg hover:bg-gray-200 mb-4"
            }
            to="/"
          >
            <img
              src={logo}
              alt=""
              className="w-8 h-8 rounded-full object-contain"
            />
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "bg-gray-200 flex flex-col items-center px-4 py-2 rounded-lg mb-2"
                : "flex flex-col items-center px-4 py-2 rounded-lg hover:bg-gray-200 mb-2"
            }
            to="/home"
          >
            <HomeIcon className="w-6 h-6" />
            <span className="text-xs truncate">Accueil</span>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "bg-gray-200 flex flex-col items-center px-4 py-2 rounded-lg mb-2"
                : "flex flex-col items-center px-4 py-2 rounded-lg hover:bg-gray-200 mb-2"
            }
            to="/explore"
          >
            <ArchiveIcon className="w-6 h-6" />
            <span className="text-xs truncate">Explore</span>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "bg-gray-200 flex flex-col items-center px-4 py-2 rounded-lg mb-2 relative"
                : "flex flex-col items-center px-4 py-2 rounded-lg hover:bg-gray-200 mb-2 relative"
            }
            to="/notifications"
          >
            <BellIcon className="w-6 h-6" />
            {globalNotifications?.length > 0 && (
              <span className="text-xs text-white absolute top-0 right-5 p-1 bg-red-500 rounded-full w-4 h-4 flex items-center justify-center">
                {globalNotifications?.length}
              </span>
            )}
            <span className="text-xs truncate">Notifications</span>
          </NavLink>
        </div>
        <div>
          {user ? (
            <>
              {user?.isAdmin && (
                <>
                  <NavLink
                    end
                    className={({ isActive }) =>
                      isActive
                        ? "bg-gray-200 flex flex-col items-center px-4 py-2 rounded-lg mb-2"
                        : "flex flex-col items-center px-4 py-2 rounded-lg hover:bg-gray-200 mb-2"
                    }
                    to="/profile/posts"
                  >
                    <NewspaperIcon className="w-6 h-6" />
                    <span className="text-xs truncate">Mes Articles</span>
                  </NavLink>
                  <NavLink
                    end
                    className={({ isActive }) =>
                      isActive
                        ? "bg-gray-200 flex flex-col items-center px-4 py-2 rounded-lg mb-2"
                        : "flex flex-col items-center px-4 py-2 rounded-lg hover:bg-gray-200 mb-2"
                    }
                    to="/profile/users"
                  >
                    <UsersIcon className="w-6 h-6" />
                    <span className="text-xs truncate">Mon equipe</span>
                  </NavLink>
                </>
              )}
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "bg-gray-200 flex flex-col items-center px-4 py-2 rounded-lg mb-2"
                    : "flex flex-col items-center px-4 py-2 rounded-lg hover:bg-gray-200 mb-2"
                }
                to="/profile"
              >
                {user && user?.profilePicture ? (
                  <img
                    className="h-8 w-8 rounded-full"
                    src={user.profilePicture}
                    alt=""
                  />
                ) : (
                  <img
                    className="h-8 w-8 rounded-full"
                    src={ProfileImg}
                    alt=""
                  />
                )}
                <span className="text-xs truncate">Profile</span>
              </NavLink>
              <button
                className="hover:bg-gray-200 flex flex-col items-center px-4 py-2 rounded-lg mb-2 mx-auto"
                onClick={() => logout()}
              >
                <LogoutIcon className="w-6 h-6" />
                {/* <span className="text-xs">Déconnexion</span> */}
              </button>
            </>
          ) : (
            <>
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? "bg-gray-200 flex flex-col items-center px-4 py-2 rounded-lg mb-2"
                  : "flex flex-col items-center px-4 py-2 rounded-lg hover:bg-gray-200 mb-2"
              }
              to="https://app.solisalim.com"
            >
              <ChatIcon className="w-6 h-6" />
              <span className="text-xs truncate">Chats</span>
            </NavLink>
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? "bg-gray-200 flex flex-col items-center px-4 py-2 rounded-lg mb-2"
                  : "flex flex-col items-center px-4 py-2 rounded-lg hover:bg-gray-200 mb-2"
              }
              to="/login"
            >
              <UserIcon className="w-6 h-6" />
              <span className="text-xs truncate">Login</span>
            </NavLink>
            </>
          )}
        </div>
      </div>
      <div className="w-full">
        <MobileMenu />
        <Outlet />
      </div>
    </div>
  );
};

export default ShellLayout;
